module.exports = __webpack_public_path__ + "static/scale-model-of-aspirations-winery-in-clearwater-florida-12d8cb0c3fe2da5adde7eea7d000ba1b.png";